import React from "react";

export const WebsiteLinks = (props) => {
  return (
    <div id="links">
      <div className="containerlink">
        <div className="links text-center">
         <h2>Contact Us</h2>
         <p>Web: <a href="https://www.hertfordshirefreemasons.org.uk">www.hertfordshirefreemasons.org.uk</a></p>
         <p>Email: <a href="mailto:comms@hertfordshirefreemasons.org.uk">comms@hertfordshirefreemasons.org.uk</a></p>
         <br/> 
         <p>© Hertfordshire Provincial Grand Lodge - 2025</p> 
        </div>
      </div>
    </div>
  );
};
